/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-10 13:57:07 */

const Keys = {
  confirm: 'confirm',
  earliestTravelDate: 'earliestTravelDate',
  latestTravelDate: 'latestTravelDate',
  travelPeriod: 'travelPeriod',
  duration: 'duration'
}; export default Keys;